import { h, Component } from 'preact';
import { joinClasses, accessNested } from 'utils/utils';
import Store from 'store/store';

import s from 'components/bolt/button/button.sss';

export default class Button extends Component {

	constructor(props) {
		super(props);
		this.supportedTypes = ['primary', 'outlined', 'text', 'time', 'tag', 'floating', 'icon'];
	}

	render(props) {
		const {
			type,
			variant,
			htmlType = 'button',
			active,
			class: className,
			activeClass,
			style,
			// appData,
			trigger,
			onMouseEnter,
			onMouseLeave,
			onMouseOut,
			onMouseDown,
			onKeyDown,
			onFocus,
			tabIndex,
			disabled,
			children,
			ariaLabel,
			href,
			target,
		} = props;

		if (type && !this.supportedTypes.includes(type)) {
			console.error(`Bolt.Button does not support a type of ${type}. Supported types are: ${this.supportedTypes.join(', ')}`);
			return;
		}

		const backgroundColor = accessNested(style, 'backgroundColor');
		const allButtonStyling = accessNested(Store.get(), 'appData.styling.enableDisableAllButtonStyling.showtimes');

		let Element = 'button';
		let extraProps = { type: htmlType };
		if (href) {
			Element = 'a';
			extraProps = { href, target };
		}

		return (
			<Element
				class={joinClasses(s.container, active && s.active, allButtonStyling && s.allStyling, backgroundColor && s.noHover, s[type], s[variant], className, active && activeClass)}
				style={style}
				onClick={trigger}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				onMouseDown={onMouseDown}
				onMouseOut={onMouseOut}
				onKeyDown={onKeyDown}
				onFocus={onFocus}
				disabled={disabled}
				tabIndex={tabIndex}
				ariaLabel={ariaLabel}
				{...extraProps}
			>
				{children}
			</Element>
		);
	}
}
